/* eslint-disable react/no-multi-comp */
// @ts-ignore
import { Field } from "redux-form/dist/redux-form";
import type { BaseFieldProps, WrappedFieldProps } from "redux-form";

import Select, { type SelectProps } from "./Select";
import { generateFieldId, returnFieldState } from "./formMetaHelpers";


type SelectFieldProps = SelectProps & WrappedFieldProps;

function SelectField({
  meta,
  input,
  disabled,
  help,
  label,
  options = [],
  floating = true,
  inputLeft,
  inputRight,
  fieldProps = {},
  withoutLabel,
  ...restProps
}: SelectFieldProps) {

  const id = generateFieldId("select", meta, restProps, input);
  const { isInvalid, isValid } = returnFieldState(meta);

  return (
    <Select
      id={id}
      label={label}
      help={help}
      floating={floating}
      inputLeft={inputLeft}
      inputRight={inputRight}
      fieldProps={fieldProps}
      value={input.value}
      onChange={input.onChange}
      onFocus={input.onFocus}
      onBlur={input.onBlur}
      isInvalid={isInvalid}
      isValid={isValid}
      errorMessage={meta.error}
      disabled={meta.submitting || disabled}
      name={input.name}
      options={options}
      withoutLabel={withoutLabel}
      {...restProps} />
  );
}

function FieldHoc(props: BaseFieldProps & SelectProps) {

  return (
    <Field
      component={SelectField}
      {...props} />
  );
}

FieldHoc.Select = SelectField;

export default FieldHoc;
